/**
 * The out-of-ring count over a fighter's head (the one-bout format, user 2026-10-11; rules: systems/duelRingOut.ts): a big
 * number counting 10 -> 0 while that fighter stands outside the ring (red over the player, gold over the foe), gone the moment
 * they step back in (the count starts afresh). The HUD line: ui/duelRingOutHud.ts. Picture only.
 */
import { duelMatchOf, duelRingOutOf } from '@nine/shared';
import { UI } from '../labels';
import { globeBend } from '../globe';
import { registerRenderPass } from './registry';

registerRenderPass({
  id: 'duelRingOutMark',
  layer: 'labels',
  order: 113,
  draw({ mg, world: w, px: PX, iso, ox, oy }) {
    const st = duelMatchOf(w)?.current;
    const sys = duelRingOutOf(w);
    if (!st || !sys || st.phase !== 'fight') return;
    for (const id of [st.meId, st.foeId]) {
      const info = sys.infoOf(id);
      const e = w.get(id);
      if (!info.out || !e) continue;
      const [sx, sy] = iso.proj(e.x, e.y);
      const x = (sx + ox) * PX;
      const y = globeBend(sx + ox, sy + oy - 122 * e.scale)[1] * PX;
      const n = Math.max(0, Math.ceil(info.left));
      mg.save();
      mg.textAlign = 'center';
      mg.lineJoin = 'round';
      mg.font = `800 ${n <= 3 ? 30 : 24}px ${UI}`;
      mg.lineWidth = 4;
      mg.strokeStyle = 'rgba(12,9,14,.95)';
      mg.fillStyle = id === w.player.id ? '#ff8a70' : '#f4d08c';
      mg.strokeText(String(n), x, y);
      mg.fillText(String(n), x, y);
      mg.restore();
    }
  },
});
